import { connectSortBy } from 'instantsearch.js/es/connectors'
/*
 * Adds Avtex branded tabs to toggle between the
 * regular site index and the index sorted by date
 */
const renderSortBy = (renderOptions, isFirstRender) => {
  const {
    options,
    currentRefinement,
    refine,
    widgetParams
  } = renderOptions

  if (isFirstRender) {
    const optionsContainer = document.createElement('div')
    const ulClasses = [
      'flex',
      'leading-none',
      'text-sm',
      'border-solid',
      'items-center',
    ]
    optionsContainer.classList.add(...ulClasses)
    widgetParams.container.appendChild(optionsContainer)
  }

  const optionsContainer = widgetParams.container.querySelector('div')
  optionsContainer.innerHTML = `
    ${options
    .map(
      option => `
           <button data-toggle="${option.value}" class="font-bold hover:text-black transition-colors duration-150 cursor-pointer px-2.5 py-3 ${
        option.value === currentRefinement ? 'text-blue' : 'text-text-inactive'}" aria-selected="${option.value === currentRefinement ? 'true' : 'false'}" 
          role="option">
               ${option.label}
            </button>
        `
    )
    .join('')}
  `
  const optionLinks = optionsContainer.querySelectorAll('button')
  optionLinks.forEach(element => {
    element.addEventListener('click', event => {
      event.preventDefault()
      event.stopPropagation()
      refine(event.currentTarget.dataset.toggle)
    })
  })
}

// Create the custom widget
const customSortBy = connectSortBy(renderSortBy)

export const siteCustomSortBy = customSortBy({
  container: document.querySelector('#sort-by-container'),
  items: [
    { value: window.agSi, label: 'Most Relevant' },
    { value: window.agSid, label: 'Most Recent' }
  ]
})
